import React from 'react';
import {View} from 'react-native';
import {InnerProps} from './model';

import {useStyles} from '../../../../../../shared/hooks/styles';
import {Checkbox} from '../../../../../../shared/components/baseField/components/checkbox/checkbox';
import {Text} from '../../../../../../shared/components/text';
import {DeviceSize} from '../../../../../../shared/theme/helpers';

export default (props: InnerProps) => {
  const styles = useStyles(({theme, mediaOnly}) => {
    return {
      container: {
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        alignItems: 'center',
        justifyContent: 'space-between',
      },
      label: {
        ...mediaOnly(DeviceSize.desktop, theme.fonts.label, theme.fonts.bodySmallLight),
        color: theme.color.labelText,
        width: '80%',
      },
      checkBox: {
        color: theme.color.primaryColor,
      },
    };
  });
  return (
    <View style={styles.container}>
      <Text testID={`checkbox-${props.id}-title-id`} style={styles.label}>
        {props.title}
      </Text>
      <Checkbox
        value={props.value}
        disabled={props.disabled}
        onChange={() => props.onClick()}
        testIDprefix={`checkbox-${props.id}`}
      />
    </View>
  );
};
